<template>
  <v-card style="overflow: auto" tile flat>
    <v-card-title class="text-h6 blue lighten-5">
      Présences
      <v-spacer></v-spacer>
      <v-btn small color="green" dark @click="openAddDialog">
        <v-icon left small>mdi-plus</v-icon>
        Ajouter
      </v-btn>
    </v-card-title>
    <v-dialog v-model="dialog" max-width="600px">
      <record-form
        :formTitle="formTitle"
        :record="presence"
        :items="statuts"
        selectLabel="* Statut"
        selectField="statut"
        :workingDays="workingDays"
        @save="handleSavePresence"
        @cancel="dialog = false"
      ></record-form>
    </v-dialog>
    <v-data-table
      item-key="presences.key"
      :loading="loading"
      :headers="headers"
      :items="presences"
      :no-data-text="'Aucun'"
      class="mytable_presences"
      indeterminate
      sort-by="id"
      sort-desc
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.date | dateToHuman }}</td>
            <td>{{ item.statut }}</td>
            <td>{{ item.comment }}</td>
            <td class="spacy">
              <v-btn text icon color="green" @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn text icon color="red" @click="deleteItem(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Presence from "@/models/Presence"
import StudentCourse from "@/models/StudentCourse"
import Course from "@/models/Course"
import RecordForm from "@/components/common/RecordForm"
import { notify } from "@/services/notification"
import { mapGetters } from "vuex"

export default {
  components: {
    RecordForm,
  },
  async mounted() {
    await this.getDataFromApi()
    this.updatePresences()
    this.loading = false
  },
  watch: {
    student_course_id: async function (show) {
      this.updatePresences()
    },
  },
  props: {
    student_course_id: {
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    presence: null,
    presences: [],
    formTitle: "Ajouter une présence",
    headers: [
      { text: "Date", value: "date", align: "left", width: "120px" },
      { text: "Statut", value: "statut", align: "left", width: "200px" },
      { text: "Commentaire", value: "comment" },
      { text: "Actions", value: "name", sortable: false, width: "100px" },
    ],
    loading: true,
  }),
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    statuts() {
      return Presence.statuts(false, this.isAdmin).filter((s) => s.value !== "présent")
    },
    workingDays() {
      const sc = StudentCourse.find(this.student_course_id)
      if (sc?.course_id) {
        const course = Course.find(sc.course_id)
        return course?.working_days || []
      }
      return []
    },
  },
  methods: {
    async getDataFromApi() {
      this.loading = true
      await Presence.getByStudentCourseId(this.student_course_id)
      this.loading = false
    },
    openAddDialog() {
      this.formTitle = "Ajouter une présence"
      this.presence = {
        student_course_id: this.student_course_id,
        date: "",
        statut: "",
        comment: "",
      }
      this.dialog = true
    },
    editItem(item) {
      this.formTitle = "Modifier une présence"
      this.presence = { ...item }
      this.dialog = true
    },
    deleteItem(item) {
      confirm("Êtes-vous sûr de vouloir supprimer cette donnée") &&
        (this.loading = true) &&
        Presence.deleteOne(item.id).finally(async () => {
          await this.updatePresences()
        })
    },
    async handleSavePresence(presence) {
      this.dialog = false
      this.loading = true
      try {
        if (presence.id) {
          await Presence.put(presence)
          // If status is "présent", backend deletes the record - remove from store
          if (presence.statut === "présent") {
            Presence.delete(presence.id)
          }
        } else {
          await Presence.postMultiple(presence, [presence.date])
        }
        await this.updatePresences()
        notify("success", "Sauvegardé")
      } catch (error) {
        notify("error", "Erreur lors de la sauvegarde")
      } finally {
        this.loading = false
      }
    },
    async updatePresences() {
      if (!this.student_course_id) {
        return
      }
      // Clear stale records from store before fetching fresh data
      Presence.delete((presence) => presence.student_course_id === this.student_course_id)
      await this.getDataFromApi()
      this.presences = Presence.query()
        .where("student_course_id", this.student_course_id)
        .with("student_course", (query) => {
          query.with("student").with("course")
        })
        .orderBy("date", "desc")
        .get()
      // if student from evam, add evam codes
      this.addEvamCodes()
    },
    addEvamCodes() {
      this.presences.forEach((presence) => {
        if (presence?.student_course?.student?.assistant?.mandat === "EVAM") {
          presence.statut = presence.statut + presence.evamCode
        }
      })
    },
  },
}
</script>
